import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Button,
  Divider
} from 'semantic-ui-react'

const CardWorkScheduleUX = (props: any) => {
    return(
      <div
        id="CardWorkScheduleUX-div-0"
        style={{width: "100%",height:"100%",padding:"8px 0"}}>
        <Form
          id="CardWorkScheduleUX-Form-1">
          <FormGroup
            id="CardWorkScheduleUX-FormGroup-3"
            inline={true}
            style={{margin: "2px", marginBottom: "0.5rem", padding: "0 8px"}}>
            <FormField
              id="CardWorkScheduleUX-FormField-4"
              inline={true}
              style={{display: props.filteredTabMenu?.includes("SetupSchedule")?"":"none"}}>
              <Button
                color={props.activeTab === "SetupSchedule" ? "blue" : undefined}
                id="CardWorkScheduleUX-Button-5"
                onClick={() => props.onHandleChangeTab("SetupSchedule")}
                size="small">
                Set Up Work Schedule
              </Button>
            </FormField>
            <FormField
              id="CardWorkScheduleUX-FormField-6"
              inline={true}
              style={{display: props.filteredTabMenu?.includes("SetupShiftsTemplate")?"":"none"}}>
              <Button
                color={props.activeTab === "SetupShiftsTemplate" ? "blue" : undefined}
                id="CardWorkScheduleUX-Button-10"
                onClick={() => props.onHandleChangeTab("SetupShiftsTemplate")}
                size="small">
                Set Up Work Shifts Template
              </Button>
            </FormField>
            <FormField
              id="CardWorkScheduleUX-FormField-7"
              inline={true}
              style={{display: props.filteredTabMenu?.includes("Attendance")?"":"none"}}>
              <Button
                color={props.activeTab === "Attendance" ? "blue" : undefined}
                id="CardWorkScheduleUX-Button-11"
                onClick={() => props.onHandleChangeTab("Attendance")}
                size="small">
                Employee Attendance
              </Button>
            </FormField>
            <FormField
              id="CardWorkScheduleUX-FormField-8"
              inline={true}
              style={{display: props.filteredTabMenu?.includes("LeaveRequest")?"":"none"}}>
              <Button
                color={props.activeTab === "LeaveRequest" ? "blue" : undefined}
                id="CardWorkScheduleUX-Button-12"
                onClick={() => props.onHandleChangeTab("LeaveRequest")}
                size="small">
                Employee Leave Request
              </Button>
            </FormField>
            <FormField
              id="CardWorkScheduleUX-FormField-16"
              inline={true}
              style={{display: props.filteredTabMenu?.includes("EmployeeTraining")?"":"none"}}>
              <Button
                color={props.activeTab === "EmployeeTraining" ? "blue" : undefined}
                id="CardWorkScheduleUX-Button-17"
                onClick={() => props.onHandleChangeTab("EmployeeTraining")}
                size="small">
                Employee Training
              </Button>
            </FormField>
            <FormField
              id="CardWorkScheduleUX-FormField-18"
              inline={true}
              style={{display: props.filteredTabMenu?.includes("TrainingManagement")?"":"none"}}>
              <Button
                color={props.activeTab === "TrainingManagement" ? "blue" : undefined}
                id="CardWorkScheduleUX-Button-19"
                onClick={() => props.onHandleChangeTab("TrainingManagement")}
                size="small">
                Training Management
              </Button>
            </FormField>
            <FormField
              id="CardWorkScheduleUX-FormField-9"
              inline={true}
              style={{display: props.filteredTabMenu?.includes("Summary")?"":"none"}}>
              <Button
                color={props.activeTab === "Summary" ? "blue" : undefined}
                id="CardWorkScheduleUX-Button-13"
                onClick={() => props.onHandleChangeTab("Summary")}
                size="small">
                Summary Work Hour/Month
              </Button>
            </FormField>
          </FormGroup>
        </Form>
        <Divider
          fitted={true}
          id="CardWorkScheduleUX-Divider-15">
        </Divider>
        <div
          id="CardWorkScheduleUX-div-14">
          {props.displayTab}
        </div>
      </div>
    )
}


export default CardWorkScheduleUX

export const screenPropsDefault = {}

/* Date Time : Fri Jul 04 2025 18:46:10 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWorkScheduleUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\",height:\"100%\",padding:\"8px 0\"}"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWorkScheduleUX-Form-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWorkScheduleUX-FormGroup-3"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"2px\", marginBottom: \"0.5rem\", padding: \"0 8px\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWorkScheduleUX-FormField-4"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"SetupSchedule\")?\"\":\"none\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "Button",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "Set Up Work Schedule"
        },
        "color": {
          "type": "code",
          "value": "props.activeTab === \"SetupSchedule\" ? \"blue\" : undefined"
        },
        "id": {
          "type": "value",
          "value": "CardWorkScheduleUX-Button-5"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onHandleChangeTab(\"SetupSchedule\")"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWorkScheduleUX-FormField-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"SetupShiftsTemplate\")?\"\":\"none\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWorkScheduleUX-FormField-7"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"Attendance\")?\"\":\"none\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWorkScheduleUX-FormField-8"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"LeaveRequest\")?\"\":\"none\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWorkScheduleUX-FormField-9"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"Summary\")?\"\":\"none\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "Button",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "Set Up Work Shifts Template"
        },
        "color": {
          "type": "code",
          "value": "props.activeTab === \"SetupShiftsTemplate\" ? \"blue\" : undefined"
        },
        "id": {
          "type": "value",
          "value": "CardWorkScheduleUX-Button-10"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onHandleChangeTab(\"SetupShiftsTemplate\")"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "Button",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "Employee Attendance"
        },
        "color": {
          "type": "code",
          "value": "props.activeTab === \"Attendance\" ? \"blue\" : undefined"
        },
        "id": {
          "type": "value",
          "value": "CardWorkScheduleUX-Button-11"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onHandleChangeTab(\"Attendance\")"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "Button",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": "Employee Leave Request"
        },
        "color": {
          "type": "code",
          "value": "props.activeTab === \"LeaveRequest\" ? \"blue\" : undefined"
        },
        "id": {
          "type": "value",
          "value": "CardWorkScheduleUX-Button-12"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onHandleChangeTab(\"LeaveRequest\")"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "Button",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "Summary Work Hour/Month"
        },
        "color": {
          "type": "code",
          "value": "props.activeTab === \"Summary\" ? \"blue\" : undefined"
        },
        "id": {
          "type": "value",
          "value": "CardWorkScheduleUX-Button-13"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onHandleChangeTab(\"Summary\")"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.displayTab"
        },
        "id": {
          "type": "value",
          "value": "CardWorkScheduleUX-div-14"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "Divider",
      "parent": 0,
      "props": {
        "fitted": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardWorkScheduleUX-Divider-15"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWorkScheduleUX-FormField-16"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"EmployeeTraining\")?\"\":\"none\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "Button",
      "parent": 16,
      "props": {
        "children": {
          "type": "value",
          "value": "Employee Training"
        },
        "color": {
          "type": "code",
          "value": "props.activeTab === \"EmployeeTraining\" ? \"blue\" : undefined"
        },
        "id": {
          "type": "value",
          "value": "CardWorkScheduleUX-Button-17"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onHandleChangeTab(\"EmployeeTraining\")"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWorkScheduleUX-FormField-18"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"TrainingManagement\")?\"\":\"none\"}"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "Button",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": "Training Management"
        },
        "color": {
          "type": "code",
          "value": "props.activeTab === \"TrainingManagement\" ? \"blue\" : undefined"
        },
        "id": {
          "type": "value",
          "value": "CardWorkScheduleUX-Button-19"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onHandleChangeTab(\"TrainingManagement\")"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 19,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardWorkScheduleUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
